import { TravelTypes } from '../constants';
import getLowestCostForRow from './getLowestCostForRow';

const getLowestCostItineraryFromItineraryRows = (travelOption) => {
  if (!travelOption) return null;

  if (travelOption.mode !== TravelTypes.cruise) return travelOption;

  if (travelOption.mode === TravelTypes.cruise
    && (!travelOption.itineraryRows || !travelOption.itineraryRows.length)) return null;

  let minCostRow = travelOption.itineraryRows[0];
  let minPrice = travelOption.itineraryRows[0].costInsideFrom.price;
  travelOption.itineraryRows.forEach((r) => {
    const cost = getLowestCostForRow(r);
    if (cost.price && (!minPrice || minPrice > cost.price)) {
      minPrice = cost.price;
      minCostRow = r;
    }
  });
  return minCostRow;
};

export default getLowestCostItineraryFromItineraryRows;
